import { looksInternalError, toCustomerError } from '../utils/customerError';

import { API_BASE_URL } from '../config/apiEndpoints';

function toFriendlyAuthError(raw, status, fallback) {
  const lower = (raw || '').toLowerCase();
  if (status === 409 || lower.includes('already registered') || lower.includes('already exists')) {
    return 'This email is already registered. Please log in instead.';
  }
  if (status === 400) {
    if (looksInternalError(raw)) {
      if (lower.includes('password')) return 'Please check the password requirements.';
      if (lower.includes('email')) return 'Please enter a valid email address.';
      return 'Invalid request. Please check your input.';
    }
    if (lower.includes('password')) return raw || 'Please check the password requirements.';
    if (lower.includes('email')) return raw || 'Please enter a valid email address.';
    return raw || 'Invalid request. Please check your input.';
  }
  if (status === 401 || status === 403) return 'Invalid credentials. Please try again.';
  if (status >= 500) return 'The server is temporarily unavailable. Please try again in a moment.';
  return toCustomerError(raw, { status, fallback });
}

const authApiService = {
  async register({ email, password, first_name, last_name, role = 'customer', phone = '' }) {
    const response = await fetch(`${API_BASE_URL}/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, first_name, last_name, role, phone }),
    });

    let data = {};
    try {
      data = await response.json();
    } catch {
      data = {};
    }

    if (!response.ok) {
      const raw = data?.detail || data?.message || '';
      const message = toFriendlyAuthError(raw, response.status, 'Registration failed. Please try again.');
      const error = new Error(message);
      error.status = response.status;
      throw error;
    }

    return data;
  },

  async verifyEmail(token) {
    const response = await fetch(`${API_BASE_URL}/auth/verify-email?token=${encodeURIComponent(token)}`);

    let data = {};
    try {
      data = await response.json();
    } catch {
      data = {};
    }

    if (!response.ok) {
      const raw = data?.detail || data?.message || '';
      const message = toFriendlyAuthError(raw, response.status, 'Verification link is invalid or expired. Please request a new one.');
      const error = new Error(message);
      error.status = response.status;
      throw error;
    }

    return data;
  },

  async login(email, password) {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    let data = {};
    try {
      data = await response.json();
    } catch {
      data = {};
    }

    if (!response.ok) {
      const raw = data?.detail || data?.message || '';
      const message = toFriendlyAuthError(raw, response.status, 'Login failed. Please try again.');
      const error = new Error(message);
      error.status = response.status;
      throw error;
    }

    return data;
  },
};

export default authApiService;
